export const PARAMETERS = 'parameters';

// SSM0010
export const SSM0010_TREATMENT_KEY = 'ssm-0010';
export const SSM0010_GROUP_PARAMETER_KEY = 'group';
export const SSM0010_GROUP_PARAMETER_OPTIONS = Object.freeze({
  control: 'control',
  variant: 'variant'
});

// HC-0136
export const HC_0136_TREATMENT_KEY = 'hc-0136';
export const HC_0136_GROUP_PARAMETER_KEY = 'group';
export let HC_0136_GROUP_PARAMETER_OPTIONS;
(function (HC_0136_GROUP_PARAMETER_OPTIONS) {
  HC_0136_GROUP_PARAMETER_OPTIONS["control"] = "control";
  HC_0136_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(HC_0136_GROUP_PARAMETER_OPTIONS || (HC_0136_GROUP_PARAMETER_OPTIONS = {}));